function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgMobile(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("circle", {
    cx: 48,
    cy: 79,
    r: 4
  }), React.createElement("path", {
    d: "M64.117 2H29.882C22.228 2 16 8.228 16 15.882v64.236C16 87.772 22.228 94 29.882 94h34.236C71.772 94 78 87.772 78 80.118V15.882C78 8.228 71.772 2 64.117 2zM70 80.118A5.89 5.89 0 0164.118 86H29.882A5.89 5.89 0 0124 80.118V73h46v7.118zM70 65H24V24h46v41zM23.937 16.02s.63-6.066 6.548-6.067c5.953-.002 5.099.031 5.099.031l-.003.016h28.536A5.89 5.89 0 0170 15.882V16H34.651"
  }));
}

SvgMobile.clsName = 'icon-www__mobile';
SvgMobile.remarkName = 'unknown';
export default SvgMobile;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Mobile.js
// module id = 2391
// module chunks = 17 18